import React, { useCallback } from 'react';
import { Divider, Tooltip, message, Flex, Button } from 'antd';
import DefaultButton from '../ui-kit/buttons/DefaultButton';
import { NEXT_PUBLIC_URL } from 'util/constants';
import ChangeSceneAlias from './nav-editor-actions/ChangeSceneAlias';
import { memo } from 'react';
import { previewIcon, shareIcon } from './icons';
import styles from '../navigation-bar/navigation-bar.module.css';

interface Props {
  isSignIn: boolean;
  ref1?: any;
  ref2?: any;
  ref3?: any;
  setIsSaveScene: Function | undefined;
  sceneId: string | undefined;
  hasChanges?: boolean;
}

const NavigationButtons: React.FC<Props> = ({
  isSignIn,
  sceneId,
  setIsSaveScene,
  ref1,
  ref2,
  ref3,
  hasChanges = true,
}) => {
  const isNewTemplatePage = window.location.href.includes('/new-template');
  const copy = () => {
    navigator.clipboard.writeText(`${NEXT_PUBLIC_URL}scene/${sceneId}`);
    message.success('Link copied');
  };

  function onPreviewScene() {
    if (setIsSaveScene) {
      setIsSaveScene(true);
    }

    setTimeout(() => {
      window.open(`/scene/${sceneId}`, '_blank', 'noreferrer');
    }, 100);
  }

  const saveScene = useCallback(() => {
    if (setIsSaveScene) {
      setIsSaveScene(true);
    }
  }, [setIsSaveScene]);

  return (
    <>
      {isSignIn && (
        <Flex align='center' className={styles.sceneNameWrapper}>
          <ChangeSceneAlias sceneId={sceneId} />
          <Divider type='vertical' className={styles.divider} />
        </Flex>
      )}
      {isSignIn && (
        <div className={styles.buttonsWrapper}>
          <Tooltip title='Preview'>
            <div ref={ref1} style={{ marginRight: isSignIn ? 5 : 0 }}>
              <Button
                type='default'
                className={styles.previewButton}
                onClick={onPreviewScene}
              >
                {previewIcon}
              </Button>
            </div>
          </Tooltip>
          <Tooltip title='Share'>
            <div ref={ref2}>
              <Button
                type='default'
                className={styles.shareButton}
                onClick={copy}
              >
                {shareIcon}
              </Button>
            </div>
          </Tooltip>
          <Divider type='vertical' className={styles.divider} />
        </div>
      )}
      <div style={{ marginLeft: isSignIn ? 0 : 160 }} ref={ref3}>
        <DefaultButton
          type='primary'
          style={{ minHeight: 32 }}
          onClick={saveScene}
        >
          <img
            src={'/save-icon.svg'}
            alt='icon'
            width={17}
            height={17}
            style={{ marginTop: -2, marginRight: 5 }}
          />
          <span style={{ color: '#fff' }}>Save</span>
        </DefaultButton>
      </div>

      <Divider type='vertical' className={styles.divider} />
    </>
  );
};

export default memo(NavigationButtons);
